export enum SubscriptionType {
  PROFESSIONAL = 'professional',
  ENTERPRISE = 'enterprise',
}
